<template>
     <div class="row">{{tabActiveFunction}}
        <div class="col-12">
            <ul class="fixedMiddleHeaderTab d-flex align-items-center holderCss">
                <li :class="(loadServiceRequest == 'requestServiceElement')? 'active' : ''" v-on:click.prevent="enableRequestElement('requestServiceElement')"><a href="#">{{$t('suppIndex_requestServices')}}</a></li>
                <li :class="(loadServiceRequest == 'openRequest')? 'active' : ''" v-on:click.prevent="enableRequestElement('openRequest')"><a href="#" > {{$t('suppIndex_OpenRequests')}}</a></li>
                <li :class="(loadServiceRequest == 'closeRequest')? 'active' : ''" v-on:click.prevent="enableRequestElement('closeRequest')"><a href="#">{{$t('suppIndex_ClosedRequests')}} </a></li>
            </ul>
        </div>
        <div class="col-12" v-if="loadServiceRequest == 'requestServiceElement'">
             <div class="ServceRequest">
                <app-request-services ></app-request-services>
             </div>
        </div>
        <div class="col-12 mb-4"  v-if="loadServiceRequest == 'openRequest'">
             <app-ticket-support ></app-ticket-support> 
        </div>
        <div class="col-12 mb-4" v-if="loadServiceRequest == 'closeRequest'">
            <app-ticket-support ></app-ticket-support>
        </div>



         <!---------------------------------------------Contact Form--------------------------------------------------->

       

    </div>
    
</template>
<script>      
    import { fxViewMixins } from '@/plugins/fxView'  
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import requestServices from './request_services'
    import ticketSupport from './support'
    export default {
        name: 'SERVICES',
        mixins: [fxViewMixins],
        data () {
          return {
            loadServiceRequest : "requestServiceElement",
            ticket_status : "",
            pageLoader : false,
            loaderFuncRun : '1',
            setView : '',
          }
        }, 
        components: {
            appRequestServices: requestServices,
            appTicketSupport: ticketSupport
        },
        computed:{
            tabActiveFunction(){
                localStorage.setItem("tabName", this.$route.params.tabName);
                this.loadServiceRequest = localStorage.getItem("tabName", this.$route.params.tabName);
                this.ticket_status = (this.loadServiceRequest == 'openRequest' ? '0' : '3')
            }
        },
        methods:{
            enableRequestElement(elementName){
                this.loadServiceRequest = elementName
                this.$router.replace({ name: "fxView.support", params: {tabName:elementName}})
            }
        },
        created(){
            if(this.$store.getters[Const.GET_TICKET_REASON_LIST] != ''){
                this.loaderFuncRun = '0'
            }

            if(this.$route.params.page && this.$route.params.page  == 'view_dash'){
                this.setView = 'view_dash'
                this.enableRequestElement('openRequest')
            }
            this._runGetTicketReasonList({ 'globalParams' :{ },'localParams' :{"parameter" : this ,'loaderFuncRun' : this.loaderFuncRun}})
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/supports/index.vue